import React from "react";
import "./ImageWithSource.css";

const ImageWithSource = ({ src, alt = "", overlayText, link }) => {
  return (
    <a href={link} target="_blank" rel="noopener noreferrer" className="image-link">
      <div className="image-wrapper">
        <img src={src} className="group-image" alt={alt} />
        <div className="image-overlay">
          {overlayText || src}
        </div>
      </div>
    </a>
  );
};

export default ImageWithSource;
